/**
 * MeetingVenueService
 * Service for MeetingVenue entity operations
 * Route: api/meetingvenues
 * Controller: MeetingVenuesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingVenueService
 * Handles meeting venue CRUD operations
 * Maps to /api/meetingvenues endpoint
 */
export class MeetingVenueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingVenueService.DEFAULT_SERVICE_PATH,
            basePath: MeetingVenueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingVenueService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingVenueService.BASE_PATH = 'api/meetingvenues';
//# sourceMappingURL=MeetingVenueService.js.map